module.exports = __webpack_public_path__ + "static/media/csvExampleImg.4b7c5b9e.png";